import img from "../assests/images/white-logo.png";

export default function Footer() {
  return (
    <footer className="relative overflow-hidden bg-[#173F3E] text-[#FBFAF6]">

      {/* Decorative Background */}
      <div className="absolute -right-40 -top-40 h-96 w-96 rounded-full bg-[#B78932]/10 blur-3xl" />
      <div className="absolute -left-40 bottom-0 h-80 w-80 rounded-full bg-[#0B5552]/50 blur-3xl" />

      {/* Top Gold Line */}
      <div className="h-px w-full bg-gradient-to-r from-transparent via-[#B78932] to-transparent" />

      <div className="relative mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12 xl:px-16">

        {/* MAIN FOOTER */}
        <div className="grid gap-12 py-14 sm:py-16 lg:grid-cols-12 lg:gap-10 lg:py-20">

          {/* BRAND */}
          <div className="lg:col-span-4">

            <a
              href="https://marinadubai.com"
              className="
    flex
    shrink-0
    items-center
    transition-transform
    duration-300
    hover:scale-[1.02]
  "
            >
              <img
                src={img}
                alt="Dubai Hotel Rates"
                className="
      block
      h-auto
      w-[140px]
      object-contain
      sm:w-[155px]
      md:w-[170px]
      lg:w-[185px]
      xl:w-[195px]
    "
              />
            </a>

            <div className="mt-4 flex items-center gap-3">
              <span className="h-px w-10 bg-[#B78932]" />

              <span className="text-[10px] font-semibold uppercase tracking-[0.3em] text-[#D5A33C]">
                Stay Better. Choose Better.
              </span>
            </div>

            <p className="mt-6 max-w-sm text-sm leading-7 text-[#C7D0CC]">
              Discover exceptional hotels across Dubai,
              compare rates with confidence, and find a stay
              that makes your Dubai experience unforgettable.
            </p>

            {/* Social Icons */}
            <div className="mt-7 flex items-center gap-3">

              {/* Facebook */}
              <a
                href="https://www.facebook.com/SouthTravelsOfficialPage/"
                aria-label="Facebook"
                className="flex h-10 w-10 items-center justify-center border border-[#E7DED0]/20 text-[#D9DEDA] transition-all duration-300 hover:border-[#B78932] hover:bg-[#B78932] hover:text-[#173F3E]"
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="h-4 w-4"
                >
                  <path d="M14 8h3V4h-3c-3.31 0-5 1.69-5 5v3H6v4h3v8h4v-8h3l1-4h-4V9c0-.69.31-1 1-1Z" />
                </svg>
              </a>

              {/* Instagram */}
              <a
                href="https://www.instagram.com/southtravels8376/"
                aria-label="Instagram"
                className="flex h-10 w-10 items-center justify-center border border-[#E7DED0]/20 text-[#D9DEDA] transition-all duration-300 hover:border-[#B78932] hover:bg-[#B78932] hover:text-[#173F3E]"
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.7"
                  className="h-4 w-4"
                >
                  <rect
                    x="3"
                    y="3"
                    width="18"
                    height="18"
                    rx="5"
                  />
                  <circle cx="12" cy="12" r="4" />
                  <circle
                    cx="17.5"
                    cy="6.5"
                    r="1"
                    fill="currentColor"
                    stroke="none"
                  />
                </svg>
              </a>

              {/* X */}
              <a
                href="https://x.com/SouthTravels"
                aria-label="X"
                className="flex h-10 w-10 items-center justify-center border border-[#E7DED0]/20 text-[#D9DEDA] transition-all duration-300 hover:border-[#B78932] hover:bg-[#B78932] hover:text-[#173F3E]"
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="h-4 w-4"
                >
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24h-6.657l-5.214-6.817-5.965 6.817H1.682l7.73-8.835L1.254 2.25H8.08l4.713 6.231 5.45-6.231Zm-1.161 17.52h1.833L7.084 4.126H5.117L17.083 19.77Z" />
                </svg>
              </a>

              {/* LinkedIn */}
              <a
                href="https://www.linkedin.com/company/southtravelsuae/"
                aria-label="LinkedIn"
                className="flex h-10 w-10 items-center justify-center border border-[#E7DED0]/20 text-[#D9DEDA] transition-all duration-300 hover:border-[#B78932] hover:bg-[#B78932] hover:text-[#173F3E]"
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="h-4 w-4"
                >
                  <path d="M5.04 3.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5ZM3 9h4v12H3V9Zm6 0h3.83v1.64h.05c.53-1 1.83-2.06 3.77-2.06 4.03 0 4.77 2.65 4.77 6.1V21h-4v-5.6c0-1.34-.02-3.06-1.87-3.06-1.87 0-2.16 1.46-2.16 2.96V21H9V9Z" />
                </svg>
              </a>

            </div>
          </div>


          {/* EXPLORE */}
          <div className="lg:col-span-2 lg:col-start-6">

            <h3 className="font-serif text-lg text-[#FBFAF6]">
              Explore
            </h3>

            <div className="mt-5 h-px w-8 bg-[#B78932]" />

            <ul className="mt-5 space-y-3">

              <li>
                <a
                  href="https://marinadubai.com"
                  className="text-sm text-[#C7D0CC] transition-colors duration-300 hover:text-[#D5A33C]"
                >
                  Dubai Hotels
                </a>
              </li>

              <li>
                <a
                  href="https://marinadubai.com"
                  className="text-sm text-[#C7D0CC] transition-colors duration-300 hover:text-[#D5A33C]"
                >
                  Hotel Deals
                </a>
              </li>

              <li>
                <a
                  href="https://marinadubai.com"
                  className="text-sm text-[#C7D0CC] transition-colors duration-300 hover:text-[#D5A33C]"
                >
                  Compare Rates
                </a>
              </li>

              <li>
                <a
                  href="https://marinadubai.com"
                  className="text-sm text-[#C7D0CC] transition-colors duration-300 hover:text-[#D5A33C]"
                >
                  Luxury Hotels
                </a>
              </li>

              <li>
                <a
                  href="https://marinadubai.com"
                  className="text-sm text-[#C7D0CC] transition-colors duration-300 hover:text-[#D5A33C]"
                >
                  Beachfront Hotels
                </a>
              </li>

            </ul>
          </div>


          {/* COMPANY */}
          <div className="lg:col-span-2">

            <h3 className="font-serif text-lg text-[#FBFAF6]">
              Company
            </h3>

            <div className="mt-5 h-px w-8 bg-[#B78932]" />

            <ul className="mt-5 space-y-3">

              <li>
                <a
                  href="https://marinadubai.com"
                  className="text-sm text-[#C7D0CC] transition-colors duration-300 hover:text-[#D5A33C]"
                >
                  About Us
                </a>
              </li>

              <li>
                <a
                  href="https://marinadubai.com"
                  className="text-sm text-[#C7D0CC] transition-colors duration-300 hover:text-[#D5A33C]"
                >
                  Contact Us
                </a>
              </li>

              <li>
                <a
                  href="https://marinadubai.com"
                  className="text-sm text-[#C7D0CC] transition-colors duration-300 hover:text-[#D5A33C]"
                >
                  Help Center
                </a>
              </li>

              <li>
                <a
                  href="https://marinadubai.com"
                  className="text-sm text-[#C7D0CC] transition-colors duration-300 hover:text-[#D5A33C]"
                >
                  Careers
                </a>
              </li>

              <li>
                <a
                  href="https://marinadubai.com"
                  className="text-sm text-[#C7D0CC] transition-colors duration-300 hover:text-[#D5A33C]"
                >
                  Partner With Us
                </a>
              </li>

            </ul>
          </div>


          {/* CONTACT */}
          <div className="lg:col-span-3">

            <h3 className="font-serif text-lg text-[#FBFAF6]">
              Contact Us
            </h3>

            <div className="mt-5 h-px w-8 bg-[#B78932]" />

            <div className="mt-6 space-y-5">

              {/* Phone */}
              <a
                href="tel:+971 50 247 7593"
                className="group flex items-start gap-4"
              >
                <span className="flex h-10 w-10 shrink-0 items-center justify-center border border-[#E7DED0]/20 text-[#D5A33C] transition-all duration-300 group-hover:border-[#B78932] group-hover:bg-[#B78932] group-hover:text-[#173F3E]">

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="h-4 w-4"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.09l-4.423-.906a1.125 1.125 0 0 0-1.173.417l-.97 1.293c-.351.468-.924.648-1.463.4a12.035 12.035 0 0 1-6.083-6.083c-.248-.539-.068-1.112.4-1.463l1.293-.97c.39-.293.57-.789.417-1.173L7.54 4.085A1.125 1.125 0 0 0 6.45 3.25H5.078A2.25 2.25 0 0 0 2.25 5.5v1.25Z"
                    />
                  </svg>

                </span>

                <span>
                  <span className="block text-[10px] font-semibold uppercase tracking-[0.2em] text-[#9EAAA5]">
                    Phone
                  </span>

                  <span className="mt-1 block text-sm text-[#D9DEDA] transition-colors group-hover:text-[#D5A33C]">
                    +971 50 247 7593
                  </span>
                </span>
              </a>


              {/* Email */}
              <a
                href="mailto:info@southtravels.com"
                className="group flex items-start gap-4"
              >
                <span className="flex h-10 w-10 shrink-0 items-center justify-center border border-[#E7DED0]/20 text-[#D5A33C] transition-all duration-300 group-hover:border-[#B78932] group-hover:bg-[#B78932] group-hover:text-[#173F3E]">

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="h-4 w-4"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25H4.5a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0l-7.5-4.615A2.25 2.25 0 0 1 2.25 6.993V6.75"
                    />
                  </svg>

                </span>

                <span>
                  <span className="block text-[10px] font-semibold uppercase tracking-[0.2em] text-[#9EAAA5]">
                    Email
                  </span>

                  <span className="mt-1 block text-sm text-[#D9DEDA] transition-colors group-hover:text-[#D5A33C]">
                    info@southtravels.com
                  </span>
                </span>
              </a>


              {/* Location */}
              <div className="group flex items-start gap-4">

                <span className="flex h-10 w-10 shrink-0 items-center justify-center border border-[#E7DED0]/20 text-[#D5A33C] transition-all duration-300 group-hover:border-[#B78932] group-hover:bg-[#B78932] group-hover:text-[#173F3E]">

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="h-4 w-4"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                    />

                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z"
                    />
                  </svg>

                </span>

                <span>
                  <span className="block text-[10px] font-semibold uppercase tracking-[0.2em] text-[#9EAAA5]">
                    Location
                  </span>

                  <span className="mt-1 block text-sm leading-6 text-[#D9DEDA]">
                    Office 302, 3rd Flr. HDS Tower Cluster F, Jumeirah Lakes Towers Dubai
                  </span>
                </span>

              </div>

            </div>

          </div>

        </div>


        {/* FOOTER BOTTOM */}
        <div className="border-t border-[#E7DED0]/15 py-6">

          <div className="flex flex-col items-center justify-between gap-4 text-center sm:flex-row sm:text-left">

            <p className="text-xs text-[#9EAAA5]">
              © {new Date().getFullYear()} Marina Dubai.
              All rights reserved.
            </p>

            <div className="flex items-center gap-2 text-xs text-[#9EAAA5]">
              <span>
                Made for travelers who expect more
              </span>

              <span className="text-[#B78932]">
                ✦
              </span>

              <span>
                Dubai, UAE
              </span>
            </div>

          </div>

        </div>

      </div>
    </footer>
  );
}
